import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
import React, { useEffect, useState } from 'react'
import { CardIconBox, ContainerBox } from '../element/element'
import { FrontApi } from '../../../../api/front-api/front.api'
import { decodeId } from '../../../../utils/app.utils'
import { Avatar, Box, Button, IconButton, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../store/store'
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import moment from 'moment'
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import StepperCustom from '../../../../components/step/Stepper'
import { AcademicAndResearch, EducationDetail, ProfileDetail, WorkExperienceDetail } from './element'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { IconComponents } from '../../../../assets/icons/icons'
import { saveAs } from 'file-saver'
import { useLocation, useParams } from 'react-router-dom'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'
import { ARTICLE_TYPE } from '../../../cms/personnel-management/enum/enum-personnel'
import { alertError } from '../../../../components/alert/swal'


type Props = {}

const OrganizationalDetail: React.FC = ({ }: Props) => {
    const { id } = useParams();
    const { t } = useTranslation();
    // const { id_employee } = useParams<{ id_employee: string }>();
    const location = useLocation();
    const dispatch = useDispatch();
    const path_name = location.pathname
    const id_employee = decodeId(id || "");
    const public_img = useSelector((state: RootState) => state.api.image_api);

    type dataDetails = {
        full_name: string;
        profile_image: string | null;
        position: string;
        work_experience: string;
    }
    const [data, setData] = useState<dataDetails>({
        full_name: "",
        profile_image: "",
        position: "",
        work_experience: ""
    })
    const [dataDetail, setDataDetail] = useState<any>(null);
    const [step, setStep] = useState<number>(0);
    const [employee_background_social_media, set_employee_background_social_media] = useState<any[]>([]);
    const [employee_article, set_employee_article] = useState<any[]>([]);
    const [employee_award, set_employee_award] = useState<any[]>([]);
    const [content_data, _set_content_data] = useState<{
        id: number;
        icon: React.ReactNode;
        key: string;
        link: string;
    }[]>([
        {
            id: 1,
            key: "FACEBOOK",
            icon: <IconComponents.FacebookColorIcon />,
            link: ""
        },
        {
            id: 2,
            key: "INSTAGRAM",
            icon: <IconComponents.IGColorIcon />,
            link: ""
        },
        {
            id: 3,
            key: "X",
            icon: <IconComponents.XColorIcon />,
            link: ""
        },
        {
            id: 4,
            key: "YOUTUBE",
            icon: <IconComponents.YoutubeColorIcon />,
            link: ""
        },
    ])

    const work_experience_cal = (start_date: string): string => {
        const start = moment(start_date);
        const now = moment();
        let result = "";
        const years = now.diff(start, "years");
        if (years > 0) {
            result = t("{{years}} ปี", { years });
        } else {
            const months = now.diff(start, "months");
            if (months > 0) {
                result = t("{{months}} เดือน", { months });
            } else {
                const days = now.diff(start, "days");
                result = t("{{days}} วัน", { days });
            }
        }
        return result
    }

    const handleOpenSocialMedia = (link?: string | null) => {
        const raw = link?.trim();
        if (!raw) return;
        const url = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
        try {
            const valid_url = new URL(url);
            if (valid_url.protocol !== 'http:' && valid_url.protocol !== 'https:') return;
            window.open(valid_url.href, '_blank', 'noopener,noreferrer');
        } catch (error) {
            console.warn('invalid social media link:', raw);
        }
    }

    const handleDownloadExcel = async (id_employee: number) => {
        dispatch(setLoading());
        await FrontApi.employeeDownload(id_employee).then((res) => {
            if (res.status < 300) {
                const data = res.data;
                const content_type = res.headers['content-type']!;
                const blob_file = new Blob([data], { type: String(content_type || "") });
                saveAs(blob_file, 'cv_download')
            }
        }).catch((err) => {
            console.log(err)
            alertError(err?.response?.data?.message || t("เกิดข้อผิดพลาดในการดาวน์โหลดไฟล์"));
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetDetail = async (id_employee: number) => {
        dispatch(setLoading());
        await FrontApi.employeeDetail(id_employee).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data;
                setDataDetail(response);
                const employee_article_res = response?.employee_article || [];
                const employee_award_res = response?.employee_award || [];
                set_employee_article(employee_article_res);
                set_employee_award(employee_award_res);
                set_employee_background_social_media(response?.employee_background_social_media || []);
                const full_name = `${response?.first_name || ""} ${response?.last_name || ""}`;
                const profile_img = response?.employee_image ? `${public_img}/${response?.employee_image?.file_path}` : null
                const text_experience_work = work_experience_cal(response?.employee_work?.date_start_work);
                setData((prev) => (
                    {
                        ...prev,
                        full_name,
                        profile_image: profile_img,
                        position: response?.position?.position_name || "-",
                        work_experience: text_experience_work
                    }
                ))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        if (id_employee) {
            handleGetDetail(id_employee)
        }
    }, [id_employee])
    return (
        <ContainerBox>
            <NavigateListCustom
                navigateData={[
                    {
                        key: "แผนผังองค์กร", // i18n-ignore (React key only)
                        name: t('HOME_PAGE_ORGANIZATIONAL_CHART'),
                        pathName: routeName.main.organization,
                    },
                    {
                        key: "detail",
                        name: data?.full_name,
                        pathName: path_name
                    },
                ]}
            />

            <Box className="flex flex-col md:flex-row  justify-center items-center md:justify-start gap-5" py={5}>
                <Box className="w-full max-w-[259px] h-[259px] rounded-[50%] overflow-hidden">
                    {data.profile_image ? (
                        <img
                            className='object-cover w-full h-full'
                            src={data.profile_image}
                            alt="profile"
                        />
                    ) : (
                        <Avatar sx={{ width: "100%", maxWidth: '259px', height: "259px" }} />
                    )}
                </Box>
                <Box className="flex flex-col gap-2 justify-center items-start">
                    <Typography variant='h5'>
                        {data.full_name}
                    </Typography>
                    <Typography variant='subtitle2' sx={{
                        color: "#9E640E",
                        fontSize: 'calc(1vw+1.2vmin)'
                    }}>
                        {dataDetail?.employee_work?.position?.position_name || "-"}
                    </Typography>

                    {/* ต้อง publish ด้วย ถึงแสดง */}
                    {dataDetail?.employee_background && (
                        <Box className="w-full flex gap-3 items-center justify-between">
                            <Box className="flex flex-wrap gap-1">
                                {content_data?.map((list) => {
                                    return (
                                        <Box key={list.id}>
                                            <IconButton onClick={() => {
                                                const path = employee_background_social_media?.find((x) => x?.social_media?.icon === list.key)?.background_social_media_link;
                                                handleOpenSocialMedia(path);
                                            }}>
                                                {list.icon}
                                            </IconButton>
                                        </Box>
                                    )
                                })}
                            </Box>
                            <Box>
                                <Button onClick={() => id_employee && handleDownloadExcel(id_employee)} variant='contained' color='success'>
                                    Download My CV
                                </Button>
                            </Box>
                        </Box>
                    )}

                </Box>
            </Box>
            <Box>
                <CardIconBox data={[
                    {
                        id: 1,
                        detail: dataDetail ? work_experience_cal(dataDetail?.employee_work?.date_start_work) : data.work_experience,
                        icon: <QueryBuilderIcon sx={{ width: "100%", maxWidth: "80px", height: "80px" }} />,
                        title: t("HOME_PAGE_WORKING_AGE")
                    },
                    // {
                    //     id: 2,
                    //     detail: `${dataDetail?.article_count} รายการ`,
                    //     icon: <FolderOutlinedIcon sx={{ width: "100%", maxWidth: "80px", height: "80px" }} />,
                    //     title: "จำนวนงานวิจัยหรือผลงาน"
                    // },
                    {
                        id: 3,
                        detail: dataDetail?.employee_work?.position?.position_name || "-",
                        icon: <BadgeOutlinedIcon sx={{ width: "100%", maxWidth: "80px", height: "80px" }} />,
                        title: t("HOME_PAGE_JOB_POSITION")
                    },
                ]} />
            </Box>


            <Box py={5}>
                <StepperCustom
                    setStep={(st) => {
                        setStep(st);
                    }}
                    step={step}
                    view
                    sx={{ maxWidth: { xs: "300px", sm: "500px", xl: "1000px" } }}
                    mode='tab'
                    stepLabel={[
                        {
                            isAccept: true,
                            name: t('HOME_PAGE_GENERAL_INFORMATION/PROFILE')
                        },
                        {
                            isAccept: true,
                            name: t("HOME_PAGE_EDUCATIONAL_RECORD")
                        },
                        {
                            isAccept: true,
                            name: t("HOME_PAGE_WORK_EXPERIENCE")
                        },
                        {
                            isAccept: true,
                            name: t("HOME_PAGE_ACADEMIC_WORKS_AND_RESEARCH")
                        },
                        {
                            isAccept: true,
                            // disabled: true,
                            name: t("รางวัลและเกียรติประวัติ")
                        },
                    ]}
                />
            </Box>

            <Box my={4}>
                {step === 0 ? (
                    <ProfileDetail
                        personal_detail={{
                            age: dataDetail?.date_of_birth ? moment(new Date()).diff(moment(dataDetail?.date_of_birth), 'years').toString() : "",
                            ethnicity: dataDetail?.race,
                            full_name: (dataDetail?.first_name && dataDetail?.last_name) ? `${dataDetail?.first_name} ${dataDetail?.last_name}` : "",
                            gender: dataDetail?.gender,
                            id_card: dataDetail?.employee_no,
                            nationality: dataDetail?.nationality,
                            nick_name: dataDetail?.buddhist_name,
                            organization_email: dataDetail?.email_organization,
                            personal_email: dataDetail?.email_personal,
                            religion: dataDetail?.religion,
                            tel: dataDetail?.phone_number
                        }}
                        work_detail={{
                            current_position_name: dataDetail?.employee_work?.position?.position_name,
                            level: "",
                            organization_tel: dataDetail?.phone_work
                        }}
                    />
                ) : null}

                {step === 1 ? (
                    <EducationDetail
                        data={dataDetail?.employee_education}
                    />
                ) : null}
                {step === 2 ? (
                    <WorkExperienceDetail
                        data={dataDetail?.employee_work_history}
                    />
                ) : null}
                {step === 3 ? (
                    <AcademicAndResearch
                        academic={employee_article?.filter((x) => x?.article_type === ARTICLE_TYPE.TREATISE).map((list) => {
                            return {
                                detail: list?.article_detail || "",
                                title: list?.article_title || "",
                                link: ""
                            }
                        })}
                        article={employee_article?.filter((x) => x?.article_type === ARTICLE_TYPE.RESEARCH).map((list) => {
                            return {
                                detail: list?.article_detail || "",
                                title: list?.article_title || "",
                                link: ""
                            }
                        })}
                    />
                ) : null}
                {step === 4 ? (
                    <AcademicAndResearch
                        academic={[]}
                        enable_department
                        hidden_step
                        article={employee_award?.map((list) => {
                            return {
                                detail: t("รายละเอียด : {{desc}}", { desc: list?.desc || "" }),
                                title: list?.award_name || "",
                                link: list?.link || "",
                                department: list?.agency || ""
                            }
                        })}
                    />
                ) : null}
            </Box>
        </ContainerBox>
    )
}

export default OrganizationalDetail